module.exports = __webpack_public_path__ + "img/t_0022.ad336fa3.gif";